import Swiper, {Autoplay, Navigation, Pagination} from "swiper";

export default class HeroScene {
  constructor() {
    if (!document.querySelector('.hero-scene__swiper')) return false

    this.swiper = new Swiper('.hero-scene__swiper', {
      modules: [Autoplay, Navigation, Pagination],

      autoplay: {
          delay: 5000,
      },

      pagination: {
        el: '.hero-scene__swiper .swiper-pagination',
        clickable: true
      },

      navigation: {
        prevEl: '.hero-scene__swiper .swiper-button-prev',
        nextEl: '.hero-scene__swiper .swiper-button-next'
      }
    })
  }
}
